import { useRouteError, useNavigate, isRouteErrorResponse } from 'react-router-dom';
import { AlertTriangle, Home, RotateCw } from 'lucide-react';
import { Button } from '@/shared/ui';

/**
 * Route-level error boundary. Without this, any error thrown while rendering a
 * route (or a failed lazy chunk) blanks the screen to black. Here it renders a
 * recoverable panel instead, so navigation errors are always visible + fixable.
 */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'An unexpected error occurred.';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-base px-6 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-danger/10 text-danger">
        <AlertTriangle className="size-7" aria-hidden />
      </div>
      <div className="space-y-1.5">
        <h1 className="text-xl font-semibold text-foreground">Something went wrong</h1>
        <p className="max-w-md text-sm text-muted-foreground">{message}</p>
      </div>
      <div className="flex items-center gap-2">
        <Button onClick={() => window.location.reload()}>
          <RotateCw className="size-4" /> Reload
        </Button>
        <Button variant="secondary" onClick={() => navigate('/')}>
          <Home className="size-4" /> Go to dashboard
        </Button>
      </div>
    </div>
  );
}
